jQuery(document).on('ready', function () {

	
    // Listener for page resizing to scale page size
    window.addEventListener("resize", function(e) {
        scalePageSize();
    });

    // Variables // 
    
    var report = {};
    var pages = {};
    var currentPages = {};
    var header = '';	
    var activePage = 0;

    var header = '';
    var footer = '';
    //var paper = {};
    var originalPageWidth = 0;
    
    var compFromDate = null;
    var compToDate = null;

    var dataUsed = 'sample';

    // Init //
    //fetchData();
    async function fetchData(){
        // Set url based on report or template
        const url = template ? '/ajax/reports/builder/get-template' : '/ajax/reports/builder/get-report';
        const data = { report_id: reportID };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            // Update the variables
            ({report, pages, header, footer, paper} = data);

            // Set the page style for the report. 
            var link = document.createElement('link');
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("href", `/css/reports/${report.paper_size}-${report.orientation}.css`);
            document.head.appendChild(link);
            // Once loaded, build the report
            link.onload = function(){
                buildReport() 
                scalePageSize();
				buildNav();
            }
            
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    function buildNav(){
		// Get the page accordian element and clear it
        var pageAccordion = document.querySelector('.page_accordion');
		pageAccordion.innerHTML = '';

		// Loop through each report page and build out the nav.
        pages.forEach((page, index) => {
            var accordion = document.createElement('div');
            accordion.classList.add('accordion_wrapper');
            accordion.innerHTML = 
                `<div class="accordion_head">
                    <span class="p_body">Page ${index+1}</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 8H13.5" stroke="#4E4E54" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8 2.5V13.5" stroke="#4E4E54" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="accordion_body">
                </div>`

            var layout = JSON.parse(page.layout);

			if(layout.length > 0){
				// Loop through each widget and add it to the accordion
				layout.forEach(widget => {
					var widgetDiv = document.createElement('div');
					widgetDiv.classList.add('report_accordion_section_label');
					var widgetInner = 
						`<span class="p_body">${widget.type}</span>
						<div class="btns">
							<button class="copy"></button>
							<button class="edit"></button>
							<button class="delete"></button>
						</div>`;
					widgetDiv.innerHTML = widgetInner.trim();

					accordion.querySelector('.accordion_body').appendChild(widgetDiv);

				});
			}
			
			// Add an 'Add Widget' button to the end of each pages accordion
            var addWidgetBtn = document.createElement('a');
            addWidgetBtn.href = '#';
            addWidgetBtn.classList.add('add_widget_btn');
            addWidgetBtn.setAttribute('data-modal', 'add_section');
            addWidgetBtn.innerHTML = 
                `<svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.78125 11.5H18.2187" stroke="#8362F9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3.9375V19.0625" stroke="#8362F9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>Add Widget</span>`;

			addWidgetBtn.addEventListener('click', function (e) {
				e.preventDefault();
				document.getElementById('add_section').parentElement.classList.add('active');
				document.querySelector('body').classList.add('fixed_body');
			});

            accordion.querySelector('.accordion_body').appendChild(addWidgetBtn);
            // Finally, add it to the page.
            pageAccordion.appendChild(accordion);
        });

    }

    // Builder functions //
    function buildReport(){
        header = 
            `<div class="page-header" style="background: ${report.header_color}; text-color: ${report.header_text_color}; font-family: ${report.header_font};">
                <img class="grid-image" src="${report.logo_src}">
                <span class="text-right">
                    ${report.header_text}
                    ${report.include_date_range ? '<br><small> Some date range </small>' : ''}
                </span>
            </div>`;
        footer = 
            `<div class="page-footer" style="background: ${report.footer_colour}; text-color: ${report.footer_text_colour}; font-family: ${report.footer_font};">
                <div><span class="page-number"></span></div>
                <div>${report.footer_text}</div>
            </div>`;

        // Iterate through pages 
        pages.forEach((page, index) => {
            // Build the page's html
            buildPage(`p${page.id}`, page.position);            
            // Grab the layout and build the grid
            var layout = JSON.parse(page.layout);
            buildGrid(`p${page.id}`, `p${page.id}-grid`, layout);
            // Add page to global variable
            currentPages[`p${page.id}`] = {
                id: page.id,
                pageNum: `Page ${(index+1)}`,
                layout: layout
            };
            updatePageSelectors();
            refreshWidgets(`p${page.id}`);
        });

        originalPageWidth = document.querySelector('.page').clientWidth;
    }

    function buildPage(id, pos){
        // Get page container element
        var pageContainer = document.querySelector('.report_main');
        // Create and append the page element
        var pageEl = document.createElement('div');
        pageEl.id = id;
        pageEl.className = 'page';

        var headerEl = document.createElement('div');
        headerEl.innerHTML = header.trim();
        pageEl.appendChild(headerEl.firstChild);

        // Create and append the page content
        var pageContentEl = document.createElement('div');
        pageContentEl.className = 'page-content';
        pageEl.appendChild(pageContentEl);

        // Create and append the gridstack.js element
        var gridStackEl = document.createElement('div');
        gridStackEl.className = 'grid-stack'
        gridStackEl.id = pageEl.id+'-grid';
        pageContentEl.appendChild(gridStackEl);

        // Create and append the footer
        var footerEl = document.createElement('div')
        footerEl.innerHTML = footer.trim();
        pageEl.appendChild(footerEl.firstChild);

        // Append to page container
        pageContainer.appendChild(pageEl);

        // Update the page number in the footer
        document.querySelector(`#${pageEl.id} .page-footer .page-number`).innerHTML = pos;

    }

    function buildGrid(pageID, el, layout=null){
        var grid = GridStack.init({
            float: true,
            acceptWidgets: true
        }, el);

        // Apply saved layout
        if(layout && layout.length > 0){
            grid.load(layout);    
        }

        // Add the edit button to all items
        var items = grid.getGridItems();
        items.forEach(item => {
            addEditButton(item, pageID);
        });

        // Set Grid Events //
        grid.on('change', function(event, items) {
            // If the widget is a chart, reload it
            items.forEach(item => {
                if(item.attributes && item.attributes.type.includes('chart')){
                    console.log('reloading chart')
                    reloadChart(item);
                }
            });
            savePage(grid, pageID);
        });

        grid.on('removed', function(event, items) {
            items.forEach(item => {
                console.log('removed', pageID);
                savePage(grid, pageID);
            });
        });

        grid.on('added', function(event, items) {
            console.log('added', pageID);
            items.forEach(item => {
                if(item.type == 'ga'){
                    generateGAWidget(item);
                }
                if(item.type == 'gsc'){
                    generateGSCWidget(item);
                }
                
                addEditButton(item.el, pageID);
            });
            savePage(grid, pageID);
        });
        
        grid.on('dragstart', function(event, el) {
            var grids = document.querySelectorAll('.grid-stack').forEach(element => {
                element.style.border = 'solid 1px #cc3131';
            });
        });
        grid.on('dragstop', function(event, el) {
            var grids = document.querySelectorAll('.grid-stack').forEach(element => {
                element.style.border = '';
            });
        }); 
        // End Grid Events //
        
    }

    // Add/Remove functions //
    async function newPage(){   
        // Count current pages:
        var position = 1;
        for (page in currentPages){
            position++;
        }
        // Create a new page in the DB
        var page = await addPage(position);
        // Set page element id
        id = `p${page.id}`;
        // Add the page to the global variable
        currentPages[id] = page;
		// Rebuild the nav
		buildNav();
        // Build page and gridstack
        buildPage(id, position);
        buildGrid(id, `${id}-grid`);
        // Update the page selectors on modals
        scalePageSize();
        updatePageSelectors();
    }

    function addEditButton(item, pageID){
        // Get item id from DOM
        var itemID = item.getAttribute('gs-id');
        // Create an edit div
        var editEl = document.createElement('div');
        editEl.className = 'edit-widget';
        // Create and add the icon
        var iconEl = document.createElement('i');
        iconEl.className = 'fas fa-ellipsis-h';
        // Set the onClick function
        iconEl.onclick = function() {editWidget(itemID, pageID);};
        // Append the new elements
        editEl.appendChild(iconEl);
        item.appendChild(editEl);
    }

    function addWidget(page, widget){
        // Get the page's gridstack element
        var grid = document.querySelector('#'+page+'-grid').gridstack;
        // Check if the new widget will fit on the page
        if (grid.willItFit(widget)) {
            // Add the new widget
            grid.addWidget(widget);
        }
        else {
            alert('Not enough free space to place the widget');
            return false;
        }
        // Confirm widget added
        return true;
    }

    function removeWidget(page, itemID){
        // Get the page's gridstack element
        var grid = document.querySelector('#'+page+'-grid').gridstack;
        // Get item element. Select first with matching gs-id
        var itemEl = document.querySelector(`[gs-id="${itemID}"`);
        grid.removeWidget(itemEl)
    }

    // Edit functions //
    function editWidget(itemID, pageID){
        // Find the widget in the global variable
        var item = currentPages[pageID].layout.filter(widget => {
            return widget.id === itemID;
        })[0]; // Return first as based on unique ids

        // Call function based on widget's type
        switch(item.type){
            case 'ga':
                editGAWidget(item, pageID);
                break;
            case 'gsc':
                editGSCWidget(item, pageID);
                break;
            case 'textarea':
                editTextareaWidget(item, pageID);
                break;
            case 'image':
                editImageWidget(item, pageID);
                break;
            case 'heading':
                editHeadingWidget(item, pageID);
                break;

        }
    }
    
    // Update functions //
    function updatePageSelectors(){
        // Create array of new option list
        var options = []
        for( page in currentPages ){
            options.push(`<option value="${page}">${currentPages[page].pageNum}</option>`);
        }
        // Delete current options and append new ones.
        document.querySelectorAll('.pageSelector option').forEach(option => {
            option.remove();
        });

        var selects = document.querySelectorAll('.pageSelector');
        selects.forEach(select => {
            options.forEach(option => {
                let optionContainer = document.createElement('div');
                optionContainer.innerHTML = option.trim()
                select.appendChild(optionContainer.firstChild);
            });
        });
    }

    // Ajax functions // 
    async function addPage(position){
        // Create holder variable
        var newPage = {};
        var data = {
            report_id: reportID,
            template: template,
            position: position
        };

        await fetch('/ajax/reports/builder/add-page', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            // Create page object to be returned
            var page = data.new_page;
			pages = data.pages;
            newPage = {
                id: page.id,
                pageNum: `Page ${page.position}`,
                layout: JSON.parse(page.layout)
            };
			
        })
        .catch((error) => {
            console.error('Error:', error);
        });

        return newPage;
    }

    function savePage(grid, pageID){
        // Get the page layout from gridstack
        var content = grid.save();
        // Replace the item content of any chart items, removing the apex chart element
        for(const widget in content){
            if(content[widget].content.includes(`id="chart-${content[widget].id}"`)){
                content[widget].content = `<div id="chart-${content[widget].id}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`;
            }
        }
        // Set the pages layout
        currentPages[pageID].layout = content;
        // Declare data to be posted
        const data = {
            report_id: reportID,
            template: template,
            page_id: currentPages[pageID].id,
            layout: JSON.stringify(content)
        }

        fetch('/ajax/reports/builder/save-page', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            console.log('saved');
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    function scalePageSize(){
        //var containerWidth = document.getElementById('page-container').clientWidth;
        //var ratio = containerWidth/originalPageWidth;
        //let root = document.documentElement;
        //root.style.setProperty('--percentage', ratio);
    }

    function refreshWidgets(pageID){
        if(currentPages[pageID].layout.length > 0){
            var gaItems = currentPages[pageID].layout.filter(widget => {
                return widget.id.includes('ga-');
            });
            gaItems.forEach((item) => {
                generateGAWidget(item);
            });

            var gscItems = currentPages[pageID].layout.filter(widget => {
                return widget.id.includes('gsc-');
            });
            gscItems.forEach((item) => {
                generateGSCWidget(item);
            });
        }
    }

    function generateGAWidget(item, refresh=false){
        const data = {
            fromDate: report.from_date,
            toDate: report.to_date,
            compFromDate: report.comp_from_date,
            compToDate: report.comp_to_date,
            widgetType: item.attributes.type,
            gaOptions: JSON.stringify(item.attributes.gaOptions),
            chartOptions: JSON.stringify(item.attributes.chartOptions)
        };

        fetch('/ajax/reports/widgets/analytics', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            if(item.attributes.type.includes('chart')){
                renderChart(item, data.original.options, refresh);
            }else if(item.attributes.type === 'stat-boxes'){
                renderStatBoxes(data, item, 'Google Analytics');
            }else if(item.attributes.type === 'table'){
                renderTable(data, item, 'Google Analytics');
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    function generateGSCWidget(item, refresh=false){
        const params = {
            fromDate: report.from_date,
            toDate: report.to_date,
            compFromDate: report.comp_from_date,
            compToDate: report.comp_to_date,
            widgetType: item.attributes.type,
            gscOptions: JSON.stringify(item.attributes.gscOptions),
            chartOptions: JSON.stringify(item.attributes.chartOptions)
        };

        fetch('/ajax/reports/widgets/search-console', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        })
        .then(response => response.json())
        .then(data => {
            console.log(item);
            if(item.attributes.type.includes('chart')){ 
                renderChart(item, data.original.options, refresh);
            }else if(item.attributes.type === 'stat-boxes'){
                console.log('render stat-boxes');
            }else if(item.attributes.type === 'table'){
                console.log('render table');
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    function renderChart(item, chartOptions, refresh){
        if(refresh){
            ApexCharts.exec(item.attributes.chartOptions.chart.id, 'destroy');
        }
        
        var chartContainer = document.querySelector(`#chart-${item.id}`); //TODO: Change references of 'chart-' to 'widget-'
        chartContainer.innerHTML = '';

        var chart = new ApexCharts(chartContainer, chartOptions);
        chart.render();
    }

    function reloadChart(item){
        console.log('chart-id', item.attributes.chartOptions.chart.id);
        ApexCharts.exec(item.attributes.chartOptions.chart.id, 'updateOptions', {}, false);
    }

    function renderStatBoxes(data, item, source){

        var container = document.querySelector(`#chart-${item.id}`);
        container.style.height = '100%';
        container.innerHTML = '';

        const row = document.createElement('div');
        row.classList.add('row');
        row.classList.add('h-100');

        for(const stat in data['stats']){
            colWidth = 12/Object.keys(data['stats']).length;
            const statBox = 
                `<div class="col">
                    <div class="widget-stat-box">
                        <div class="stat-source">
                            ${source}
                        </div>
                        <div class="stat-value text-center">
                            <h1>${data['stats'][stat]}</h1>
                            <p>${stat} ${data['name']}</p>
                        </div>
                    </div>
                </div>
                `;

            row.innerHTML += statBox;
        }

        container.appendChild(row);
            
    }

    function renderTable(data, item, source){

        var container = document.querySelector(`#chart-${item.id}`);
        container.innerHTML = '';

        const tableContainer = document.createElement('div');
        const tableLayout = `
            <table class="table table-striped h-100">
                <thead>
                    <tr>
                        <th>${data['dimension']}</th>
                        <th>${data['name']}</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        `;

        tableContainer.innerHTML = tableLayout.trim();
        const table = tableContainer.firstChild;
        const tableBody = table.querySelector('tbody');
        
        const rows = [];
        for(const dimension in data['stats']){
            rows.push(`
                <tr>
                    <td>${dimension}</td>
                    <td>${data['stats'][dimension]}</td>
                </tr>
            `)
        }

        rows.forEach(row => {
            let rowContainer = document.createElement('tbody');
            rowContainer.innerHTML = row.trim();
            tableBody.appendChild(rowContainer.firstChild);
        });

        container.appendChild(table);
            
    }


	// Data type toggle buttons
	document.querySelectorAll('.toggle_btns button').forEach(btn => {
		btn.addEventListener('click', function () {
			if (btn.classList.contains('toggled')) {
				btn.classList.remove('toggled');
				if(btn.nextElementSibling){
					btn.nextElementSibling.classList.add('toggled');
				}else{
					btn.previousElementSibling.classList.add('toggled');
				}
			}else{
				btn.classList.add('toggled');
				if(btn.nextElementSibling){
					btn.nextElementSibling.classList.remove('toggled');
				}else{
					btn.previousElementSibling.classList.remove('toggled');
				}
				
			}
		})
	});

	$('[data-trigger]').on('click', function (e) {
		e.preventDefault();
		var value = $(this).data('trigger');
		if (value == 'one-time') {
			$('[data-date="monthly"]').fadeOut();
		} else if (value == 'monthly') {
			$('[data-date="monthly"]').fadeIn();
		}
	});

	$('#continueSchedule').on('click', function () {
		$('#schedule_report1').hide();
		$('#schedule_report2').fadeIn();
		var parent = $(this).parents('.section_modal_footer');
		parent.find('.step_item').removeClass('current');
		parent.find('.step_item:first-of-type').addClass('completed');
		parent.find('.step_item:nth-of-type(2)').addClass('current');
		$(this).hide();
		$('#continueSchedule2').fadeIn();
	});

	$('#continueSchedule2').on('click', function () {
		$('.schedule_step').hide();
		$('.schedule_report_final').fadeIn();
	});

	$('.tag_item').on('click', function(e){
		e.preventDefault();
		let insertDiv = $(this).text();
		$('#txtarea').focus();
		pasteHtmlAtCaret('<span class="text_var"  contenteditable="false">' + insertDiv + '</span>');
		$('.text_var').on('click', function () {
			$(this).remove();
		});
	});
	
	
	function pasteHtmlAtCaret(html) {
			var sel, range;
			if (window.getSelection) {
					sel = window.getSelection();
					if (sel.getRangeAt && sel.rangeCount) {
							range = sel.getRangeAt(0);
							range.deleteContents();
							var el = document.createElement("div");
							el.innerHTML = html;
							var frag = document.createDocumentFragment(), node, lastNode;
							while ( (node = el.firstChild) ) {
									lastNode = frag.appendChild(node);
							}
							range.insertNode(frag);
							if (lastNode) {
									range = range.cloneRange();
									range.setStartAfter(lastNode);
									range.collapse(true);
									sel.removeAllRanges();
									sel.addRange(range);
							}
					}
			} else if (document.selection && document.selection.type != "Control") {
					document.selection.createRange().pasteHTML(html);
			}
	}

	if ($(window).width() <= 1024){
		$(".datepicker").datepicker({
			numberOfMonths: 1,
			maxDate: 0,
			beforeShowDay: function(date) {
				var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input1").val());
				var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input2").val());
				return [true, date1 && ((date.getTime() == date1.getTime()) || (date2 && date >= date1 && date <= date2)) ? "dp-highlight" : "ssss"];
			},
			onSelect: function (dateText, inst) {
				var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input1").val());
				var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input2").val());
								var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, dateText);
								if (!date1 || date2) {
					$("#input1").val(dateText);
					$("#input2").val("");
										$(this).datepicker();
								} else if( selectedDate < date1 ) {
										$("#input2").val( $("#input1").val() );
										$("#input1").val( dateText );
										$(this).datepicker();
								} else {
					$("#input2").val(dateText);
									$(this).datepicker();
				}
				setTimeout(function(){
					$('.dp-highlight').first().addClass('start_range');
					$('.dp-highlight').last().addClass('start_range');
				}, 10);
			},
			onChangeMonthYear: function () {
				setTimeout(function(){
					$('.dp-highlight').first().addClass('start_range');
					$('.dp-highlight').last().addClass('start_range');
				}, 10);
			}
		});
	}else {
		$(".datepicker").datepicker({
			numberOfMonths: 2,
			maxDate: 0,
			beforeShowDay: function (date) {
				var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input1").val());
				var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input2").val());
				return [true, date1 && ((date.getTime() == date1.getTime()) || (date2 && date >= date1 && date <= date2)) ? "dp-highlight" : ""];
			},
			onSelect: function (dateText, inst) {
				$.datepicker.formatDate('dd/mm/yy');
				var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input1").val());
				var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input2").val());
								var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, dateText);
								if (!date1 || date2) {
					$("#input1").val(dateText);
					$("#input2").val("");
										$(this).datepicker();
								} else if( selectedDate < date1 ) {
										$("#input2").val( $("#input1").val() );
										$("#input1").val( dateText );
										$(this).datepicker();
								} else {
					$("#input2").val(dateText);
									$(this).datepicker();
				}
				setTimeout(function(){
					$('.dp-highlight').first().addClass('start_range');
					$('.dp-highlight').last().addClass('start_range');
				}, 10);
			},
			onChangeMonthYear: function () {
				setTimeout(function(){
					$('.dp-highlight').first().addClass('start_range');
					$('.dp-highlight').last().addClass('start_range');
				}, 10);
			}
		});
	}

	$('a[data-report-days]').on('click', function (e) {
		e.preventDefault();
		let dateRange = $(this).data('report-days');
		var d = new Date();
		var d1 = new Date(d.setDate(d.getDate() - dateRange));
		var d = new Date();

		var month = d.getMonth()+1;
		var day = d.getDate();
		var output = (day < 10 ? '0' : '') + day + '/' + (month < 10 ? '0' : '') + month + '/' + d.getFullYear();

		var month1 = d1.getMonth()+1;
		var day1 = d1.getDate();
		var output1 = (day1 < 10 ? '0' : '') + day1 + '/'+ (month1 < 10 ? '0' : '') + month1 + '/' + d1.getFullYear();

		$('#input2').val(output);
		$('#input1').val(output1);
		$('.datepicker').datepicker('refresh');
		setTimeout(function () {
			$('.dp-highlight').first().addClass('start_range');
			$('.dp-highlight').last().addClass('start_range');

			if ($('.dp-highlight').first().index() == 0) {
				if ($('.dp-highlight').first().parent().is(':first-child')) {
					console.log($(this));
					$('.dp-highlight').first().removeClass('start_range');
				}
			}

		}, 10);
	});

	$('a[data-compare-days]').on('click', function (e) {
		e.preventDefault();
		let dateRange = $(this).data('compare-days');
		var d = new Date();
		var d1 = new Date(d.setDate(d.getDate() - dateRange));
		var d = new Date();

		var month = d.getMonth()+1;
		var day = d.getDate();
		var output = (day < 10 ? '0' : '') + day + '/' + (month < 10 ? '0' : '') + month + '/' + d.getFullYear();

		var month1 = d1.getMonth()+1;
		var day1 = d1.getDate();
		var output1 = (day1 < 10 ? '0' : '') + day1 + '/'+ (month1 < 10 ? '0' : '') + month1 + '/' + d1.getFullYear();

		$('#input4').val(output);
		$('#input3').val(output1);
		$('.datepicker1').datepicker('refresh');
		setTimeout(function () {
			$('.dp-highlight1').first().addClass('start_range');
			$('.dp-highlight1').last().addClass('start_range');
			
			if ($('.dp-highlight1').first().index() == 0) {
				if ($('.dp-highlight1').first().parent().is(':first-child')) {
					console.log($(this));
					$('.dp-highlight1').first().removeClass('start_range');
				}
			}

		}, 10);
	});
 

	$('#calendar_btn').on('click', function () {
		$('.calendar_settings_wrapper').toggleClass('active');
	});
	
	$('.toggle_sm_btn').on('click', function () {
		$(this).toggleClass('active');
		$(this).parents('.settings_controls_part').find('.hide_custom').fadeToggle();
		if ($(this).hasClass('active')) {
			$(".datepicker1").datepicker({
				numberOfMonths: 2,
				maxDate: 0,
				beforeShowDay: function (date) {
					var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input3").val());
					var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input4").val());
					return [true, date1 && ((date.getTime() == date1.getTime()) || (date2 && date >= date1 && date <= date2)) ? "dp-highlight1" : ""];
				},
				onSelect: function (dateText, inst) {
					$.datepicker.formatDate('dd/mm/yy');
					var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input3").val());
					var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#input4").val());
									var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, dateText);
									if (!date1 || date2) {
						$("#input3").val(dateText);
						$("#input4").val("");
											$(this).datepicker();
									} else if( selectedDate < date1 ) {
											$("#input4").val( $("#input3").val() );
											$("#input3").val( dateText );
											$(this).datepicker();
									} else {
						$("#input4").val(dateText);
										$(this).datepicker();
					}
					setTimeout(function(){
						$('.dp-highlight1').first().addClass('start_range');
						$('.dp-highlight1').last().addClass('start_range');
					}, 10);
				},
				onChangeMonthYear: function () {
					setTimeout(function(){
						$('.dp-highlight1').first().addClass('start_range');
						$('.dp-highlight1').last().addClass('start_range');
					}, 10);
				}
			});
		} else {
			$(".datepicker1").datepicker('destroy');   
		}
	});

	$(document).on('click', function () {
		$('.calendar_settings_wrapper').removeClass('active')      
	}).find('.select_date_btn').on('click', function (e) {
		e.stopPropagation();
	});
	$('.settings_controls_btn .secondary_btn').on('click', function () {
		$('#calendar_btn').trigger('click');    
	})

	$('.sidebar_toggle').on('click', function () {
		$('.report_item_sidebar_elem').fadeToggle().toggleClass('active');
	});
 
});